import React from 'react';
import { motion } from 'framer-motion';
import HelpImage from '../assets/help-section-image.png';

const HelpSection = () => {
    return (
        <section className="relative z-30 font-sans">
            {/* Wrapper to center - Pushes down into footer */}
            <div className="max-w-6xl mx-auto px-4 sm:px-6 relative -bottom-24">

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-700 rounded-3xl shadow-[0_20px_60px_-15px_rgba(79,70,229,0.5)] p-0 relative overflow-hidden flex flex-col md:flex-row items-center justify-between min-h-[180px]"
                >
                    {/* Artistic Circle Accents */}
                    <div className="absolute top-0 right-0 -mr-20 -mt-20 w-80 h-80 bg-white opacity-10 rounded-full blur-3xl pointer-events-none"></div>
                    <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-60 h-60 bg-black opacity-20 rounded-full blur-2xl pointer-events-none"></div>

                    {/* Left: Text Content */}
                    <div className="p-6 md:pl-12 md:py-10 z-10 w-full md:w-2/3 text-center md:text-left space-y-2 md:space-y-4">
                        <h2 className="text-2xl md:text-4xl font-extrabold text-white tracking-tight leading-tight" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
                            We Love to Help. <span className="opacity-80">Seriously.</span>
                        </h2>
                        <div className="flex flex-col md:flex-row items-center gap-3 md:gap-6 mt-2">
                            <div className="text-blue-100/90 text-xs md:text-sm font-medium border-r-0 md:border-r border-blue-400/30 pr-0 md:pr-6">
                                Stuck? Call us 24/7.
                            </div>

                            <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
                                <a href="tel:+919296381495" className="text-xl md:text-2xl font-bold text-white hover:text-blue-100 transition-colors">
                                    +91 92963 81495
                                </a>
                                <a href="#contact" className="bg-white text-blue-700 hover:bg-blue-50 font-bold py-1.5 px-4 md:py-2 md:px-6 rounded-full text-xs md:text-sm uppercase tracking-wider shadow-lg transition-all transform hover:-translate-y-1">
                                    Let's Talk
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Right: Image - Cutout effect */}
                    <div className="relative w-full md:w-1/3 h-full flex justify-center md:justify-end items-end self-end mt-2 md:mt-0">
                        {/* Image positioned to popup from bottom */}
                        <img
                            src={HelpImage}
                            alt="Helping Hands"
                            className="w-auto h-36 md:h-60 object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-500"
                        />
                    </div>

                </motion.div>
            </div>
        </section>
    );
};

export default HelpSection;
